

import initmixin from "@/Services/initmixin";

export default {
 
  //mixins: [initmixin],
 // GET_CLIENTES CREAR_CLIENTES EDITAR_CLIENTES ELIMINAR_CLIENTES
 GET: async function( data){
  let url='/categorias/'
  return initmixin.formatrespuesta('get', data,url,true)
},
CREAR: async function( data) {
  let url='/categorias/'
  return initmixin.formatrespuesta('post', data.data,url,true)
},
EDITAR: async function( data) {
  let url='/categorias/'+data.id
  return initmixin.formatrespuesta('post', data.data,url,true)
},
ELIMINAR: async function( data) {
  let url='/categorias/'+data.id
  return initmixin.formatrespuesta('delete', data,url,true)
},

}